import colors from './colors';
import fonts from './fonts';
const buttons = {
    buttonHeight: '3rem',
    smallButtonHeight: '2.5rem',
    borderRadius: '0.375rem',
    fontWeight: fonts.weights.bold,
    linkFontWeight: fonts.weights.bold,
    defaultIconMargin: '0 0.25rem',
    fontSize: '1rem',
    smallButtonFontSize: '0.875rem',
    smallButtonFontSizeMobile: '0.875rem',
    fontSizeMobile: '1rem',
    loadingSpinnerSize: '3rem',
    textColor: colors.gray900,
    textDecoration: 'none',
    hoverTextDecoration: 'underline',
    primary: {
        backgroundColor: colors.primaryDark,
        hoverFocusBackgroundColor: colors.orangeL20,
        color: colors.gray900,
    },
    secondary: {
        backgroundColor: colors.grayL30,
        hoverFocusBackgroundColor: colors.grayL20,
        color: colors.grayD40,
    },
    light: {
        backgroundColor: colors.white,
        hoverFocusBackgroundColor: colors.gray400,
        color: colors.grayD40,
    },
    dark: {
        backgroundColor: colors.gray900,
        hoverFocusBackgroundColor: colors.gray600,
        color: colors.white,
    },
};
export default buttons;
//# sourceMappingURL=buttons.js.map